import FadeUp from "./FadeUp";
import { DEST_IMAGES } from "../data/images";

const POSTS = [
  {
    title: "Top 7 Things to Do in Ujjain Beyond Mahakaleshwar",
    date: "12 May 2026",
    tag: "Pilgrimage",
    img: DEST_IMAGES.ujjain.card,
  },
  {
    title: "Indore to Pachmarhi: The Perfect Weekend Road Trip",
    date: "28 Apr 2026",
    tag: "Road Trip",
    img: DEST_IMAGES.pachmarhi.card,
  },
  {
    title: "A Foodie's Guide to Indore's Sarafa & Chappan",
    date: "15 Apr 2026",
    tag: "City Guide",
    img: DEST_IMAGES.indore.card,
  },
  {
    title: "Best Time to Visit Maheshwar & Omkareshwar",
    date: "02 Apr 2026",
    tag: "Travel Tips",
    img: DEST_IMAGES.maheshwar.card,
  },
];

export default function BlogSection() {
  return (
    <section id="blog" className="bg-[#f4f9fb] py-20">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <FadeUp>
          <div className="mb-10 text-center">
            <p className="section-label justify-center">← Latest News →</p>
            <h2 className="heading-xl text-3xl sm:text-4xl">
              Travel Tips &amp; Stories from India
            </h2>
          </div>
        </FadeUp>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {POSTS.map((p, i) => (
            <FadeUp key={p.title} delay={i * 0.1}>
              <article className="group flex h-full flex-col overflow-hidden rounded-card bg-white shadow-card transition-all duration-300 hover:-translate-y-1 hover:shadow-cardHover">
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={p.img}
                    alt={p.title}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-accent px-3 py-1 text-xs font-semibold text-white">
                    {p.tag}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <p className="text-xs font-medium text-navy/40">🗓 {p.date}</p>
                  <h3 className="mt-2 font-heading text-base font-bold leading-snug text-navy group-hover:text-brand">
                    {p.title}
                  </h3>
                  <a
                    href="#blog"
                    className="mt-auto inline-flex items-center gap-1 pt-4 text-sm font-semibold text-brand"
                  >
                    Read More →
                  </a>
                </div>
              </article>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
